import basicScroll from 'basicscroll'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
	init() {
		scrollReveals()
	},
	finalize() {
		// JavaScript to be fired on the blog page, after the init JS
	},
}

function scrollReveals() {
	gsap.fromTo(
		'.single-hero-content-wrap',
		{
			opacity: 0,
			x: -80,
		},
		{
			delay: 0.25,
			duration: 0.5,
			opacity: 1,
			x: 0,
		}
	)
}
